<h2 mat-dialog-title>Sync DNS Server</h2>

<button type="button" class="status-modal__close" aria-label="Close modal" (click)="close()">
  <fa-icon [icon]="['fas', 'xmark']" size="xl" />
</button>

<mat-dialog-content>
  <p>
    This action will fetch the current DNS records of all websites on the selected server from the
    DNS server and update the records displayed in the VMAX admin panel.
  </p>

  <form [formGroup]="form">
    <app-input-field
      label="Server"
      placeholder="Select Server"
      type="select"
      formControlName="server"
      [options]="serverOptions()"
    ></app-input-field>

    <app-input-field
      label="Sync Steps"
      placeholder="Enter start steps"
      type="number"
      formControlName="step"
    ></app-input-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="filled" type="button" [disabled]="form.invalid" (click)="submit()">
    Sync DNS Server
  </button>

  <button matButton="outlined" type="button" (click)="close()">Close</button>
</mat-dialog-actions>
